import { createTheme } from '@material-ui/core';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#004667',
    },
  },
  overrides: {
    MuiIconButton: {
      root: {
        backgroundColor: 'white',
        color: '#004866',
        '&:hover': {
          backgroundColor: 'rgba(0,0,0,1)',
        },
      },
    },
  },
  typography: {
    fontFamily: 'TisaSansPro-Regular, Siemreap',
    h1: {
      fontSize: '3rem',
      lineHeight: 1.5,
      fontFamily: 'TisaSansPro-Regular, Siemreap',
      '@media (max-width:600px)': {
        fontSize: '2rem',
      },
    },
  },
});
